module.exports = __webpack_public_path__ + "img/20220624162325.304b7cd3.png";